export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-italic-b1d9d9904bfca8802a631c45590b9efa.woff";